import { NextSeo } from "next-seo";
import { TripodBanner } from "@nju/feature-portal-banners";
import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../components/ClientSideRenderer";

export default function Tripod() {
  return (
    <LayoutWrapper>
      <NextSeo nofollow={true} noindex={true} />
      <Header />
      <BlockContent>
        <ClientSideOnly>
          <TripodBanner />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
